import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';
import { LoaderService } from './loader.service';
import { DialogService } from './dialog.service';
import { ErrorService } from './error.service';
import { Platform } from '@angular/cdk/platform';
import { ResponsiveService } from './responsive.service';
import { BrowserPreferencesService } from './browser-preferences.service';
import { ServerTimeService } from './server-time.service';
import { Clipboard } from '@angular/cdk/clipboard'
import { Store } from '@ngrx/store';
import { Action_Header_SetOptions } from '../store/actions/header.actions';
import { HeaderState } from '../models/rootState.model';

export type BrowserType = 'Opera' | 'Firefox' | 'Safari' | 'Chrome' | 'IE' | 'Edge' | 'Blink';
declare var window: any;
declare var opr: any;
declare var InstallTrigger: any;
declare var document: any;
declare var safari: any;

interface DownloadHeader {
  fieldTitle: string;
  fieldKey: string;
}
@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    public toast: ToastService,
    public loader: LoaderService,
    public dialog: DialogService,
    public error: ErrorService,
    public responsive: ResponsiveService,
    public preferences: BrowserPreferencesService,
    private clipboard: Clipboard,
    public platform: Platform,
    private store: Store<any>,
    private sServerTime: ServerTimeService) { }

  /**
   * Analise if the fields in newObject are equal to original object.
   * @param original Original backedup object base to compare
   * @param newObject New Object to be compared
   * @param skipFields Fiels to not analise
   */
  getObjectChanges(original: {}, newObject: {}, skipFields = []) {
    const changes = {
      fields: [],
      changes: {}
    };

    const oKeys = Object.keys(newObject);
    oKeys.forEach(k => {
      if (skipFields.includes(k)) { return; }
      if (original[k] !== newObject[k]) {
        changes.fields.push(k);
        changes.changes[k] = newObject[k];
      }
    });

    return changes;
  }

  public checkBrowser() {
    const lastBrowserWarning = localStorage.getItem('valid_browser_warning');
    if (!lastBrowserWarning && !this.isSuported()) {
      this.dialog.inform(`Você está utilizando um browser ou dispositivo que ainda não foi homologado
      e pode conter alguns problemas.<br>
        Caso você verifique algum comportamento que não seja o normal do sistema por favor
        avise o nosso suporte para que possamos corrigir o mais rápido possível.`,
        'Atenção!').then(() => {
          localStorage.setItem('valid_browser_warning', new Date().toString());
        });
    }
  }


  get serverTime() {
    return this.sServerTime.guessServerTime();
  }

  isSuported() {
    if (this.platform.IOS || this.platform.SAFARI || this.platform.TRIDENT) { return false; }

    return true;
  }

  isBrowser() {
    return this.platform.isBrowser;
  }

  downloadJsonAsCSV(data: any[], filename = 'Gioco', headers: DownloadHeader[]) {
    const csvData = this.ConvertToCSV(data, headers);

    const blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    const dwldLink = document.createElement('a');
    const url = URL.createObjectURL(blob);
    const isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  ConvertToCSV(objArray: any[], headerList: DownloadHeader[]): string {
    let str = '';
    let row = '';

    headerList.forEach(header => {
      row += header.fieldTitle + ',';
    });
    str += row + '\r\n';
    objArray.forEach((_row, i) => {
      let line = '';
      // tslint:disable-next-line: forin
      headerList.forEach((header) => {
        line += objArray[i][header.fieldKey] + ',';
      });
      str += line + '\r\n';
    });


    return str;
  }

  copyToClipboard(value: any) {
    this.clipboard.copy(value);
  }

  setHeaderOptions(options: Partial<HeaderState>) {
    setTimeout(() => {
      this.store.dispatch(new Action_Header_SetOptions(options));
    }, 100);
  }


}
